module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/234-australia-3d5c31a8d555e546df29a19f413a8827.svg";